<script lang="ts">
  import CategorySection from './CategorySection.svelte'
  import filters from '../lib/stores/filters'
  import Label from './Label.svelte'
  import type { Filter } from '../global'

  export let checkboxes: Filter.Checkbox[]
</script>

{#each checkboxes as { label, value } (`accommodation-with-${value}`)}
  <CategorySection>
    <label class="inline-flex cursor-pointer items-center">
      <input
        class="checkbox"
        type="checkbox"
        name="accommodation_with[]"
        {value}
        bind:group={$filters.accommodationWith}
      />
      <Label class="ml-3" as="span">{label}</Label>
    </label>
  </CategorySection>
{/each}
